import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M 10.113296,14.746414 C 9.2574982,14.746297 8.7227069,13.819845 9.1506206,13.078712 L 11.036153,9.8112343 c 0.427475,-0.74353 1.50022,-0.74353 1.927694,0 l 1.885532,3.2674777 c 0.427914,0.741133 -0.106876,1.667585 -0.962674,1.667702 z" />,
  'SortingUp'
);
